module.exports = __webpack_public_path__ + "img/item(17).4bc44d9f.svg";